import Model from 'offline/stream/model/base'

export default Model.extend({
	table: 'game_designer',
	key: 'game_designer_id',
	fields: {
		game_designer_id: Model.SCHEMA_NUMBER,
		game_id: Model.SCHEMA_NUMBER,
		designer_id: Model.SCHEMA_NUMBER
	}
})
